import { render, staticRenderFns } from "./CardItemSimple.vue?vue&type=template&id=bd78c35e&lang=true"
import script from "./CardItemSimple.vue?vue&type=script&lang=js"
export * from "./CardItemSimple.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports